<template>
  <f7-row class="pb-05 pt-05 border-bottom-thin-solid">
    <template>
      <f7-col>{{ source.command }}</f7-col>
      <f7-col>{{ source.number }}</f7-col>
      <f7-col class="text-align-right">{{ source.point }}</f7-col>
      <f7-col class="text-align-right">{{ source.over_point }}</f7-col>
    </template>
  </f7-row>
</template>
<script>

export default {
  props:{
    index :{ // index of current item
      type:Number
    },
    source:{
      type:Object,
      default(){
        return {}
      }
    }
  }
}
</script>
